import { render, staticRenderFns } from "./GlobalAnalyticsPage.vue?vue&type=template&id=dd9969d2&"
import script from "./GlobalAnalyticsPage.vue?vue&type=script&lang=js&"
export * from "./GlobalAnalyticsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports